import React, { useEffect, useState } from "react"
import { useForm } from "react-hook-form"
import { useDispatch, useSelector } from "react-redux"
import { publishSong } from "../../store/reducers/builderReducer"
import { CustomH2 } from "../common/customH2/CustomH2"
import { Schema } from "./Schema"
import styles from './Files.module.css'
import { AppLink } from "../common/link/AppLink"
import { AppButton } from "../common/button/AppButton"
import { AppFileInput } from "../common/input/AppFileInput"
import { useNavigate } from "react-router-dom"
import { saveFilesFormDataAC } from "../../store/actions/builderActions"

export const Files = () => {
    const { parsedSchemas, isFetching } = useSelector(state => state.builder)
    const [isDisabled, setIsDisabled] = useState(true)
    const { register, watch, handleSubmit } = useForm()
    const dispatch = useDispatch()
    const navigate = useNavigate()
    

    useEffect(() => {
        const subscription = watch(values => setIsDisabled(Object.values(values).some(value => value.length < 1)))
        return () => subscription.unsubscribe()
    }, [watch])

    const onSubmit = (formData) => {
        try {
            dispatch(saveFilesFormDataAC(formData))
            navigate('/builder/upload')
        } catch (e) {
            alert(e.code)
        }
    }

    return <div>
        <CustomH2>Upload files for your schemas:</CustomH2>
        <form
            onSubmit={handleSubmit(onSubmit)}>
            {parsedSchemas.map(schema => {
                return <div
                    className={styles.container}
                    key={schema.schema}>
                    <Schema
                        schema={schema.schema} />
                    <AppFileInput
                        register={register}
                        field={schema.schemaBoolean}
                        accept='audio/mpeg3'
                    />
                </div>
            })}
            <AppLink to='/builder/slices'>Go Back</AppLink>
            <AppButton
                disabled={isDisabled && !isFetching}
                type='submit'
                value='next' />
        </form>
        {isFetching && <div>Fetching...</div>}
    </div>
}